import styled from 'styled-components'

import colors from '@settings/styleSettings'
import Modal from 'styled-react-modal'

export const Container = Modal.styled`
  display: flex;
  flex-direction: column;
  align-items: center;

  width: 375px;
  position: absolute;
  height: 100%;
  right: 0;
  top: 0;
  background-color: ${colors.grayBackground};

  @media(max-height: 1000px) {
    overflow-y: scroll;

    ::-webkit-scrollbar {
      width: 0;
    }

    ::-webkit-scrollbar-track {
      display: none;
    }
  }

  @media (max-width: 1025px) {
    max-width: 100%;
    width: 100%;
  }

  -webkit-animation-name: fadeInRight;
  animation-name: fadeInRight;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  @-webkit-keyframes fadeInRight {
    0% {
      opacity: 0;
      -webkit-transform: translate3d(100%, 0, 0);
      transform: translate3d(100%, 0, 0);
    }
    100% {
      opacity: 1;
      -webkit-transform: none;
      transform: none;
    }
  }
  @keyframes fadeInRight {
    0% {
      opacity: 0;
      -webkit-transform: translate3d(100%, 0, 0);
      transform: translate3d(100%, 0, 0);
    }
    100% {
      opacity: 1;
      -webkit-transform: none;
      transform: none;
    }
  }
`

export const TitleContainer = styled.div`
  width: 100%;
  display: flex;
  height: 100px;
  margin-bottom: 5px;
  background-color: ${colors.background};
`

export const ItemContainer = styled.div`
  display: flex;
  margin: 12px 24px;
  padding: 12px 0;
  align-items: center;
  justify-content: space-between;

  border-bottom: 1px solid ${colors.grayBackground};
`

export const Text = styled.h3`
  font-size: 16px;
  font-weight: bold;
  font-family: Circular-Std-Bold;
`

export const ContentItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
`

export const ButtonContainer = styled.div`
  width: 40%;
`

export const LoadingContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
`
